


import React, { useState } from "react";

const gallery = [
  { id: 1, image: "/images/fleet/1.jpeg" },
  { id: 2, image: "/images/fleet/2.jpeg" },
  // { id: 3, image: "/images/fleet/3.jpeg" },
  { id: 4, image: "/images/fleet/4.jpeg" },
  { id: 5, image: "/images/fleet/5.jpeg" },
  { id: 6, image: "/images/fleet/6.jpeg" },
  { id: 7, image: "/images/fleet/7.jpeg" },
  { id: 8, image: "/images/fleet/8.jpeg" },
  { id: 9, image: "/images/fleet/9.jpeg" },
  { id: 10, image: "/images/fleet/10.jpeg" },
  { id: 11, image: "/images/fleet/11.jpeg" },
  { id: 12, image: "/images/fleet/12.jpeg" },
  { id: 13, image: "/images/fleet/13.jpeg" },
  { id: 14, image: "/images/fleet/14.jpeg" },
  { id: 15, image: "/images/fleet/15.jpeg" },
  { id: 16, image: "/images/fleet/16.jpeg" },
  { id: 17, image: "/images/fleet/17.jpeg" },
  { id: 18, image: "/images/fleet/18.jpeg" },
  { id: 19, image: "/images/fleet/19.jpeg" },

   {
    id: 1,
    name: "Swift Dzire",
    seats: "4+1 Seater",
    image: "/images/fleet/Swift-Dzire.png",
  },

  {
    id: 2,
    name: "Maruti Ertiga",
    seats: "6+1 Seater",
    image: "/images/fleet/Maruti-Ertiga.png",
  },

  {
    id: 3,
    name: "Toyota Rumion",
    seats: "6+1 Seater",
    image: "/images/fleet/Toyota-Rumion.png",
  },

  {
    id: 4,
    name: "Kia Carens",
    seats: "6+1 Seater",
    image: "/images/fleet/Kia-Carens.png",
  },

  {
    id: 5,
    name: "Innova Cab",
    seats: "7+1 Seater",
    image: "/images/fleet/Innova-Cab.png",
  },

  {
    id: 6,
    name: "Innova Crysta",
    seats: "7+1 Seater",
    image: "/images/fleet/Innova-Crysta.png",
  },

  {
    id: 7,
    name: "Tempo Traveller",
    seats: "13-17 Seater",
    image: "/images/fleet/Tempo-Traveller.png",
  },

  {
    id: 8,
    name: "Urbania Bus",
    seats: "17 Seater",
    image: "/images/fleet/Urbania-Bus.png",
  },

  {
    id: 9,
    name: "Mini Bus",
    seats: "20-32 Seater",
    image: "/images/fleet/Mini-Bus.png",
  },
];


const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
        <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Gallery</h1>
          </div>
        </div>
      </div>
      


      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
               <img src={item.image} alt={item.name} />

<div className="zoom-icon">
  <i className="fas fa-search-plus"></i>
</div>

{/* <h5>{item.name}</h5> */}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr  borderr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;